import { render, staticRenderFns } from "./TeacherList.vue?vue&type=template&id=6631d2ea&scoped=true&"
import script from "./TeacherList.vue?vue&type=script&lang=js&"
export * from "./TeacherList.vue?vue&type=script&lang=js&"
import style0 from "./TeacherList.vue?vue&type=style&index=0&id=6631d2ea&lang=scss&scoped=true&"
import style1 from "./TeacherList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6631d2ea",
  null
  
)

export default component.exports